export default "__VITE_ASSET__NGV5ogw9__"